import { createElement } from 'react'

import { Element } from 'common/interfaces'
import { DataSource } from 'components/DataSource'
import StyledWrap from 'components/StyledWrap'
import { MustacheCustomRender, useCurrentPage, useTemplateCustomRender } from 'utils/hook'
import { renderRule } from 'views/Flow/renderRule'

import components from '../componentsMap'

export function renderElement(node: Element, render?: MustacheCustomRender): JSX.Element | null {
  const Component = components[node.type]

  const isComponentRender =
    node.render_rules.length > 0 && render !== undefined
      ? renderRule(node.render_rules, render)
      : true

  if (!isComponentRender) {
    return null
  }

  if (node.events.length !== 0) {
    return <DataSource node={node} Component={Component} />
  }

  return (
    <StyledWrap elementName={node.type} key={`styled-wrap-${node.name}`}>
      {
        // eslint-disable-next-line react/no-children-prop
        createElement(Component, {
          ...node.props,
          name: node.name,
          key: node.name,
          children: node.children,
          validations: node.validations,
        })
      }
    </StyledWrap>
  )
}

export default function FormWizard(): JSX.Element {
  const page = useCurrentPage()

  const render = useTemplateCustomRender()

  return <>{page.elements.map((el) => renderElement(el, render))}</>
}
